import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M21.9235 11.6c-2.02-4.69-5.82-7.6-9.92-7.6s-7.9 2.91-9.92 7.6a1 1 0 0 0 0 .8c2.02 4.69 5.82 7.6 9.92 7.6s7.9-2.91 9.92-7.6a1 1 0 0 0 0-.8m-9.92 6.4c-3.17 0-6.17-2.29-7.9-6 1.73-3.71 4.73-6 7.9-6s6.17 2.29 7.9 6c-1.73 3.71-4.73 6-7.9 6m0-10a4.0002 4.0002 0 0 0-3.9232 4.7804 4 4 0 0 0 5.4539 2.9151A4 4 0 0 0 16.0035 12a4 4 0 0 0-4-4m0 6a1.9998 1.9998 0 0 1-1.4142-3.4142A2 2 0 1 1 12.0035 14"
}), "Show", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
